var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorthEast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 5.5,
    fill: "#FCFCFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 5.5,
    stroke: "#F1F1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7856 33.2144C21.1663 33.5952 21.7837 33.5952 22.1644 33.2144L31.55 23.8289V31.225C31.55 31.7635 31.9865 32.2 32.525 32.2C33.0635 32.2 33.5 31.7635 33.5 31.225V21.475C33.5 20.9365 33.0635 20.5 32.525 20.5H22.775C22.2365 20.5 21.8 20.9365 21.8 21.475C21.8 22.0135 22.2365 22.45 22.775 22.45H30.1711L20.7856 31.8356C20.4048 32.2163 20.4048 32.8337 20.7856 33.2144Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthEast);
export default __webpack_public_path__ + "static/media/north-east.c00bca9bcbb997d5be02c97e0e52a91b.svg";
export { ForwardRef as ReactComponent };